import PropTypes from 'prop-types';
import styled from 'styled-components';
import SegmentSwatch from './SegmentSwatch/SegmentSwatch';
import Carousel from '../Carousel/Carousel';


const SwatchesTitle = styled.div`
  font-size: 22px;
  font-weight: bold;
  padding-top: 15px;
  margin-bottom: 5px;
  border-top: 2px solid ${(props) => props.theme.colors.shades[6]};
`;

const StyledCarousel = styled(Carousel)`
  padding-bottom: 15px;
  margin-bottom: ${(props) => (props.mobile ? '5px' : '10px')};
  border-bottom: 2px solid ${(props) => props.theme.colors.shades[6]};
`;

const SwatchesGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.lastGroup ? 'flex-start' : 'center')};
  > * {
    align-self: stretch;
    width: ${(props) => (props.mobile ? '32%' : '23%')};
  }
`;

SwatchesGroup.displayName = 'SwatchesGroup';

const SegmentSwatches = ({ segmentsData, disabled, mobile, onSwatchClick }) => {
  const swatchesPerGroup = mobile ? 3 : 4;
  const numberOfSwatchesGroups = Math.ceil(segmentsData.length / swatchesPerGroup);

  const swatchesGroups = [];

  for (let i = 0; i < numberOfSwatchesGroups; i++) {
    swatchesGroups.push(
      <SwatchesGroup mobile={mobile} key={i} lastGroup={i === numberOfSwatchesGroups - 1}>
        {segmentsData.slice(i * swatchesPerGroup, i * swatchesPerGroup + swatchesPerGroup).map(
          (segmentData, index) => (
            <SegmentSwatch
              label={`${segmentData.label} (${segmentData.count})`}
              imgSrc={segmentData.imgSrc}
              mobile={mobile}
              highlighted={segmentData.selected}
              onClick={(e) => {
                e.preventDefault();
                onSwatchClick(segmentData.value, segmentData.selected);
              }}
              key={`${segmentData.value}_${segmentData.count}_${index}`} // eslint-disable-line react/no-array-index-key
            />
          )
        )}
      </SwatchesGroup>
    );
  }

  const defaultSelectedSlideIndex = segmentsData.find((segmentData) => segmentData.selected)
    ? Math.floor(segmentsData.findIndex((segmentData) => segmentData.selected) / swatchesPerGroup)
    : 0;

  return (
    <>
      <SwatchesTitle>
        {/* TODO: add to translations */}
        Top matching categories
      </SwatchesTitle>
      <StyledCarousel
        defaultSelectedSlideIndex={defaultSelectedSlideIndex}
        showNavigation={false}
        disabled={disabled}
        mobile={mobile}
        threshold={mobile ? 50 : 100}
        duration={400}
      >
        {swatchesGroups}
      </StyledCarousel>
    </>
  );
};

SegmentSwatches.propTypes = {
  segmentsData: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      count: PropTypes.string.isRequired,
      selected: PropTypes.bool.isRequired
    }).isRequired
  ).isRequired,
  disabled: PropTypes.bool,
  mobile: PropTypes.bool,
  onSwatchClick: PropTypes.func
};

SegmentSwatches.defaultProps = {
  disabled: false,
  mobile: false,
  onSwatchClick: () => {}
};

export default SegmentSwatches;
